module.exports = __webpack_public_path__ + "static/media/kc1.4ad22de4.png";